import React from 'react'
import i18n from 'i18next';
import SingleRangeSlider from "./singleRangeSlider/SingleRangeSlider";
import { FiSearch } from "react-icons/fi";
import { LuMicroscope } from "react-icons/lu";
import InfoTooltip from "./InfoTooltip";
import './FilterPanel.css';



class BiobankInput extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            collection_input: '',
            collection: [],
            collection_checked: [],
            type_input: '',
            type: [],
            type_checked: [],
            use_k_input: '',
            use_k: ['k_phenos',],
            use_k_checked: [true],
            k_phenos_input: 5,
            k_phenos_min: 0,
            k_phenos_max: 20,
            use_similarity_input: '',
            use_similarity: ['similarity',],
            use_similarity_checked: [false],
            similarity_input: 95,
            similarity_min: 80,
            similarity_max: 100,
            age_settings_input: '',
            age_settings: [],
            age_settings_checked: [],
            changing_prop_names: ['collection', 'type', 'use_k', 'use_similarity'],
            changing_prop_names_unchecked: [],
            changing_prop_checked_names: ['collection_checked', 'type_checked', 'use_k_checked', 'use_similarity_checked'],
            query: {}
        }
    }

    receiver_props = (nextProps, cur_prop_name, cur_prop_checked_name) => {
        let next_prop = this.state[cur_prop_name]
        let next_prop_checked = this.state[cur_prop_checked_name]
        if (typeof nextProps[cur_prop_name] !== 'undefined' && typeof nextProps[cur_prop_checked_name] !== 'undefined') {
            let flag = true;
            if (nextProps[cur_prop_name].length === this.state[cur_prop_name].length) {
                flag = false;
                for (const i in nextProps[cur_prop_name]) {
                    if (nextProps[cur_prop_name][i] !== this.state[cur_prop_name][i]) {
                        flag = true
                        break;
                    }
                }
            }
            if (flag) {
                next_prop = nextProps[cur_prop_name]
                next_prop_checked = nextProps[cur_prop_checked_name]
            }
        }
        return [next_prop, next_prop_checked]
    }

    receiver_props_unchecked = (nextProps, cur_prop_name) => {
        let next_prop = this.state[cur_prop_name]
        if (typeof nextProps[cur_prop_name] !== 'undefined') {
            next_prop = nextProps[cur_prop_name]
        }
        return next_prop;
    }

    componentDidUpdate(prevProps) {
        const updates = {};

        for (const i in this.state.changing_prop_names) {
            const propName = this.state.changing_prop_names[i];
            const checkedName = this.state.changing_prop_checked_names[i];

            if (prevProps[propName] !== this.props[propName] ||
                prevProps[checkedName] !== this.props[checkedName]) {
                const next_props = this.receiver_props(this.props, propName, checkedName);
                updates[propName] = next_props[0];
                updates[checkedName] = next_props[1];
            }
        }

        for (const i in this.state.changing_prop_names_unchecked) {
            const propName = this.state.changing_prop_names_unchecked[i];
            if (prevProps[propName] !== this.props[propName]) {
                updates[propName] = this.receiver_props_unchecked(this.props, propName);
            }
        }

        if (Object.keys(updates).length > 0) {
            this.setState(updates);
        }
    }

    handleCheck = (event) => {
        event.persist();
        let check_box_name = `${[event.target.name]}_checked`;
        let id = event.target.dataset.index || event.target.id;
        const checked = this.state[check_box_name];
        checked[id] = !checked[id];
        this.setState({
            ...this.state,
            [check_box_name]: checked,
        });
    }

    handleCheckK = (event) => {
        event.persist();
        let id = 0;
        // change K
        let check_box_k = `use_k_checked`;
        const checked_k = this.state[check_box_k];
        checked_k[id] = !checked_k[id];
        //change Similarity
        let check_box_sim = `use_similarity_checked`;
        const checked_sim = this.state[check_box_sim];
        checked_sim[id] = !checked_sim[id];
        this.setState({
            ...this.state,
            [check_box_k]: checked_k,
            [check_box_sim]: checked_sim,
        });
    }

    handleCheckAllButton = (event) => {
        event.persist();
        let check_box_name = `${[event.target.name]}_checked`;
        const checked = this.state[check_box_name];
        if (checked.length > 0) {
            let flag = false
            if (checked.reduce((sum, next) => sum + next) === 0) {
                flag = true
            }
            for (const id in checked) {
                checked[id] = flag
            }
            this.setState({
                ...this.state,
                [check_box_name]: checked,
            });
        }
    }

    isAllSelected = (checkedArray) => {
        return checkedArray.length > 0 && checkedArray.every(c => c);
    }

    handleChangeMaxK = (val) => {
        this.setState({
            ...this.state,
            "k_phenos_input": val
        });
    };

    handleChangeMaxSimilarity = (val) => {
        this.setState({
            ...this.state,
            "similarity_input": val
        });
    };

    handleNewRequest = (event) => {
        event.preventDefault();
        let prop_inputs = [];
        let state_prop_names = [];
        for (const i in this.state.changing_prop_names) {
            const prop_name = this.state.changing_prop_names[i]
            const prop_checked_name = this.state.changing_prop_checked_names[i]

            let prop_input = '';
            const prop_fields = this.state[prop_name];
            const prop_checks = this.state[prop_checked_name];

            for (const i in prop_checks) {
                if (prop_checks[i]) {
                    prop_input += prop_fields[i] + ",";
                }
            }
            prop_input = prop_input.slice(0, -1);
            const state_prop_name = `${prop_name}_input`
            prop_inputs.push(prop_input);
            state_prop_names.push(state_prop_name);
        }
        this.setState({
            ...this.state,
            [state_prop_names[0]]: prop_inputs[0],
            [state_prop_names[1]]: prop_inputs[1],
            [state_prop_names[2]]: prop_inputs[2],
            [state_prop_names[3]]: prop_inputs[3]
        });
        this.props.createNewRequest({
            ...this.state,
            [state_prop_names[0]]: prop_inputs[0],
            [state_prop_names[1]]: prop_inputs[1],
            [state_prop_names[2]]: prop_inputs[2],
            [state_prop_names[3]]: prop_inputs[3]
        });
    }

    renderFilterSection = (name, labelKey, tooltipKey, items, checkedArray) => {
        const allSelected = this.isAllSelected(checkedArray);

        return (
            <div className="filter-section">
                <div className="filter-header">
                    <span>{i18n.t(labelKey)}</span>
                    <InfoTooltip text={i18n.t(tooltipKey)} />
                    <button
                        type="button"
                        className="filter-select-all-btn"
                        name={name}
                        onClick={this.handleCheckAllButton}
                    >
                        {allSelected ? i18n.t('clear_all_button') : i18n.t('select_all_button')}
                    </button>
                </div>
                <div className="filter-options">
                    {items.map((item, idx) => {
                        const id = `${name}_${item}`;
                        return (
                            <label key={id} className="filter-checkbox-label">
                                <input
                                    type="checkbox"
                                    id={id}
                                    data-index={idx}
                                    name={name}
                                    value={item}
                                    checked={checkedArray[idx] || false}
                                    onChange={this.handleCheck}
                                />
                                <span>{i18n.t(id)}</span>
                            </label>
                        );
                    })}
                </div>
            </div>
        );
    }

    render() {
        return (
            <form onSubmit={this.handleNewRequest} className="filter-panel">
                <div className="filter-panel-title">
                    <LuMicroscope size={20} />
                    <span>{i18n.t("biobanks_button")}</span>
                </div>

                {this.renderFilterSection(
                    'collection',
                    'filter_collection',
                    'tooltip_filter_collection',
                    this.state.collection,
                    this.state.collection_checked
                )}

                {this.renderFilterSection(
                    'type',
                    'filter_type',
                    'tooltip_filter_type',
                    this.state.type,
                    this.state.type_checked
                )}

                {/* K cutoff setting */}
                <div className="filter-section">
                    <div className="filter-header">
                        <span>{i18n.t("filter_use_k")}</span>
                        <InfoTooltip text={i18n.t("tooltip_filter_use_k")} />
                    </div>
                    <div className="filter-options">
                        <label className="filter-checkbox-label">
                            <input
                                type="checkbox"
                                id="use_k_k_phenos"
                                data-index={0}
                                name="use_k"
                                value="k_phenos"
                                checked={this.state.use_k_checked[0] || false}
                                onChange={this.handleCheckK}
                            />
                            <span>{i18n.t("use_k_k_phenos")}</span>
                        </label>
                    </div>
                    <div className="filter-age-slider">
                        <SingleRangeSlider
                            min={this.state.k_phenos_min}
                            max={this.state.k_phenos_max}
                            onChange={() => {}}
                            changeMin={() => {}}
                            changeMax={this.handleChangeMaxK}
                            maxInit={this.state.k_phenos_input}
                        />
                    </div>
                </div>

                {/* Similarity cutoff setting */}
                <div className="filter-section">
                    <div className="filter-header">
                        <span>{i18n.t("filter_use_similarity")}</span>
                        <InfoTooltip text={i18n.t("tooltip_filter_use_similarity")} />
                    </div>
                    <div className="filter-options">
                        <label className="filter-checkbox-label">
                            <input
                                type="checkbox"
                                id="use_similarity_similarity"
                                data-index={0}
                                name="use_similarity"
                                value="similarity"
                                checked={this.state.use_similarity_checked[0] || false}
                                onChange={this.handleCheckK}
                            />
                            <span>{i18n.t("use_similarity_similarity")}</span>
                        </label>
                    </div>
                    <div className="filter-age-slider">
                        <SingleRangeSlider
                            min={this.state.similarity_min}
                            max={this.state.similarity_max}
                            onChange={() => {}}
                            changeMin={() => {}}
                            changeMax={this.handleChangeMaxSimilarity}
                            maxInit={this.state.similarity_input}
                        />
                    </div>
                </div>

                <button type="submit" className="filter-apply-btn">
                    <FiSearch size={18} />
                    {i18n.t("request_button")}
                </button>
            </form>
        )
    }
}

export {BiobankInput};
